import { useState } from "react";
import FileUpload from "./fileUpload.component";
import { apiUrls } from "../../../utils/apiUrls";
import {
  EditableTable,
  WtaHeaderCell,
} from "../editableTable/editableTable.component";
import { uploadResponseProps } from "../../../pages/contentUpload/contentUpload";
import { Table } from "rsuite";

type uploaderTypes = {
  countryId: number | null;
  windowHeight: number;
  windowWidth: number;
  triggerNotification: (value: boolean, message: string) => void;
};

const { Column, Cell } = Table;

const UploaderWithTable = ({
  countryId,
  windowHeight,
  windowWidth,
  triggerNotification,
}: uploaderTypes) => {
  const [uploadResponse, setUploadResponse] = useState<
    uploadResponseProps[] | undefined
  >(undefined);

  const verticalMid = "middle";

  return (
    <>
      <FileUpload
        key={countryId}
        url={apiUrls.uploadFile.base}
        btnName="Publish"
        countryId={countryId}
        setUploadResponse={setUploadResponse}
        triggerNotification={triggerNotification}
        windowWidth={windowWidth}
      />
      <div
        style={{ height: `${windowHeight / 2}px` }}
        className={
          uploadResponse && uploadResponse.length > 0
            ? "mt-2 upload-response-table"
            : `d-none`
        }
      >
        <EditableTable
          virtualized={true}
          headerHeight={55}
          data={uploadResponse}
          className={`${
            uploadResponse &&
            uploadResponse.length > 0 &&
            uploadResponse[0].status === "true"
              ? "text-success"
              : "text-failure"
          }`}
          rowHeight={(data) => {
            let height = 64;

            if (data && data.message) {
              const charCount = data.message.length;
              height = charCount * 1.1;
            }

            return height;
          }}
        >
          <Column align="center" flexGrow={0.5} verticalAlign={verticalMid}>
            <WtaHeaderCell>Status </WtaHeaderCell>
            <Cell dataKey="status" />
          </Column>
          <Column align="center" flexGrow={0.5} verticalAlign={verticalMid}>
            <WtaHeaderCell>Type </WtaHeaderCell>
            <Cell dataKey="type" />
          </Column>
          <Column flexGrow={1} verticalAlign={verticalMid}>
            <WtaHeaderCell>Message </WtaHeaderCell>
            <Cell dataKey="message" />
          </Column>
        </EditableTable>
      </div>
    </>
  );
};

export default UploaderWithTable;
